import { onMounted } from 'vue'
import { useNuxtApp } from '#app'

export function useWadObserver(elRef: Ref<HTMLElement | null>, callback: () => void) {
  const { $wadObserver } = useNuxtApp()

  onMounted(() => {
    if (elRef.value) {
      $wadObserver.observeElement(elRef.value)
      elRef.value.addEventListener('wadIsIntersecting', callback)
    }
  })
}
